import React from 'react';

import {Form} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';

interface ICountryInputProps {
    name: string;
    className?: string;
    inputRef?: React.Ref<HTMLSelectElement>;
    onBlur?: () => void
    onChange?: (value: string) => void
    isInvalid?: boolean;
    disabled?: boolean;
    size?: 'sm' | 'lg';
    value: string;
}

export const CountryInput = (
    {name, inputRef, className, onBlur, onChange, isInvalid, disabled, size, value}: ICountryInputProps
) => {
    const {t, i18n} = useTranslation();

    const countryOptions = React.useMemo(() => {
        // Load the english locale file to get the country codes. The country names will be translated into the current
        // language with the TFunc
        const countryNameBundle = i18n.getResourceBundle('en', 'countries');
        return Object.keys(countryNameBundle).map(countryCode => (
            <option value={countryCode} key={countryCode}>
                {t(countryCode, countryNameBundle[countryCode], {ns: 'countries'})}
            </option>
        ));
    }, [i18n, t]);

    // the two inputs as well as their `key` props are required for setting the defaultValue after loading
    return (
        <>
            {(countryOptions) ? (
                <Form.Control
                    key="realInput"
                    custom
                    as="select"
                    className={className}
                    name={name}
                    onChange={(e) => onChange?.(e.target.value)}
                    isInvalid={isInvalid}
                    disabled={disabled}
                    onBlur={onBlur}
                    size={size}
                    value={value}
                >
                    <option value="">
                        {t('common.country', 'Country')}
                    </option>
                    {countryOptions}
                </Form.Control>
            ) : (
                <Form.Control
                    key="placeholderInput"
                    custom
                    as="select"
                    className={className}
                    isInvalid={isInvalid}
                    size={size}
                    disabled
                    ref={inputRef}
                >
                    <option value="">
                        {t('common.country', 'Country')}
                    </option>
                </Form.Control>
            )}
        </>
    );
};
